import { GRADIENT_OPTIONS, BORDER_TYPES } from 'helpers/constants';
import { isDefined, getColorGradient, hexToRGBA } from 'helpers/commons';

export const updateDesign = (current, updates, platformData, updateNeeded) => {
	const {
		colors,
		booleans,
		numbers,
		fonts: { agendaDateFontStyle }
	} = updates;

	const bookingsEventColor = hexToRGBA(
		colors?.bookingsEventColor?.value ?? platformData.functions.getColor('color-8')
	);

	const wixEventsEventColor = hexToRGBA(
		colors?.wixEventsEventColor?.value ?? platformData.functions.getColor('color-8')
	);

	current.design.bookingsEventColor = bookingsEventColor;
	current.design.wixEventsEventColor = wixEventsEventColor;

	if (updateNeeded.booleans) {
		if (isDefined(booleans.lightMode)) current.design.lightMode = booleans.lightMode;
	}
	if (updateNeeded.numbers) {
		if (isDefined(numbers.calendarBorderSize))
			current.design.shadowSize = numbers.calendarBorderSize;
		if (isDefined(numbers.bodyPadding)) current.design.padding = numbers.bodyPadding;
	}
	if (updateNeeded.fonts) {
		if (isDefined(agendaDateFontStyle.size))
			current.design.agendaDayNumberFontSize = agendaDateFontStyle.size * 2.85;
		else current.design.agendaDayNumberFontSize = 40;
	}

	const rootWrapper = document.getElementById(current.rootWrapperId);
	if (platformData.options.isMobile) rootWrapper.classList.add('bc-mobile-view');
	const colorGradient = getColorGradient(
		booleans?.bgGradient,
		GRADIENT_OPTIONS[numbers?.bgGradientType ?? 0],
		colors.bgCal1,
		colors.bgCal2
	);

	let { style } = rootWrapper;
	const isTodayHighlighted = booleans.isTodayHighlight !== false;
	const containerBackground = colors?.bgCal1
		? colorGradient
		: platformData.functions.getColor('color-1');
	const todayColor = hexToRGBA(
		colors?.bgTodayHighlight?.value ?? platformData.functions.getColor('color-4')
	);
	const todayHighlightColor = isTodayHighlighted
		? todayColor
		: colors?.numberFontColor?.value || platformData.functions.getColor('color-4');

	style.setProperty(
		'--calendar-content-alternate-height',
		rootWrapper.offsetWidth * 1.3 - (current.isMobile ? 0 : 250) + 'px'
	);
	style.setProperty('--container-background', containerBackground);
	style.setProperty('--categories-background', hexToRGBA(containerBackground, 0.8));
	style.setProperty(
		'--today-highlight-background',
		isTodayHighlighted
			? hexToRGBA(
					colors?.bgTodayHighlight?.value ?? platformData.functions.getColor('color-4'),
					0.35
				)
			: 'initial'
	);
	style.setProperty('--today-highlight-color', todayHighlightColor);
	if (isDefined(numbers?.borderType))
		style.setProperty('--calendar-border-type', BORDER_TYPES[numbers?.borderType ?? 0]);
};
